"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleType = void 0;
var ModuleType;
(function (ModuleType) {
    ModuleType["concept"] = "concept";
    ModuleType["delve"] = "delve";
    ModuleType["equation"] = "equation";
    ModuleType["exactList"] = "exact-list";
    ModuleType["flashcard"] = "flashcard";
    ModuleType["flow"] = "flow";
    ModuleType["grid"] = "grid";
    ModuleType["hierarchy"] = "hierarchy";
    ModuleType["hyperFlashcard"] = "hyper-flashcard";
    ModuleType["image"] = "image";
    ModuleType["imageChange"] = "image-change";
    ModuleType["imageDescription"] = "image-description";
    ModuleType["imageLabel"] = "image-label";
    ModuleType["imageMultiChoice"] = "image-multi-choice";
    ModuleType["imageList"] = "image-list";
    ModuleType["list"] = "list";
    ModuleType["mindmap"] = "mindmap";
    ModuleType["multipleChoice"] = "multiple-choice";
    ModuleType["multiSelect"] = "multiSelect";
    ModuleType["pattern"] = "pattern";
    ModuleType["question"] = "question";
    ModuleType["textBlock"] = "text-block";
    ModuleType["toggles"] = "toggles";
    ModuleType["video"] = "video";
    ModuleType["wordfill"] = "wordfill";
    ModuleType["workedExample"] = "worked-example";
    ModuleType["wrongWord"] = "wrong-word";
    ModuleType["simpleCalculation"] = "simple-calculation";
})(ModuleType = exports.ModuleType || (exports.ModuleType = {}));
//# sourceMappingURL=Module.js.map